<div class="info" *ngIf="selectedPOS && !connected">
    <div>
        <!-- <div class="pos-title">Vend</div> -->
        <div class="POS-logo" [ngStyle]="{'background-image': 'url(../../../../../../assets/pos/vend.png)'}"></div>
        <div class="write-up">Lightspeed X-Series is a cloud-based point of sale system for retailers of all types and
            sizes. Lightspeed X-Series offers
            tools to help manage the customer experience, as well as sales, inventory, customer data and more...
        </div>
    </div>
</div>

<button type="button" (click)="connectVend()" class="btn btn-primary"
        *ngIf="!busy && !connected && vend_auth_url">Connect to Lightspeed X-Series
</button>
<div *ngIf="busy" style="display: block; margin-left: auto;text-align: right;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4" fill="transparent"
                       animationDuration=".5s">
    </p-progressSpinner>
</div>
<div class="wizard-message box center margin-top-0" *ngIf="connected && message">
    <div [innerHTML]="message"></div>
</div>
<div class="wizard-message fail center margin-top-16" *ngIf="message && !connected">
    <div [innerHTML]="message"></div>
</div>
<div *ngIf="connected" class="margin-top-16">
    <div style="font-size: 13px; text-align: center;">{{'onboarding.messages.pos_connected_info' | translate}}</div>
    <app-vend-defaults [partner]="partner" (status)="configurationUpdate($event)"></app-vend-defaults>
</div>
<div *ngIf="partner.VerificationID" class="margin-top-32">
    <div class="row">
        <div class="col-md-6">
            <button pButton (click)="skipToHubtiger()" class="p-button alternate full-width"
                    label="{{ 'onboarding.button.skip_to_hubtiger' | translate}}" *ngIf="!configurationSaved"></button>
        </div>
        <div class="col-md-6">
            <button pButton type="button" (click)="done()" class="p-button primary full-width"
                    [disabled]="!configurationSaved"
                    label="{{ 'onboarding.button.done' | translate}}"></button>
        </div>
    </div>
</div>
